
const LoadingSpinner = ({ message = "Chargement en cours..." }) => {
  return (
    <div className="d-flex justify-content-center align-items-center py-5">
      <div className="text-center">
        <div className="spinner-border text-primary mb-3" role="status" style={{ width: '3rem', height: '3rem' }}>
          <span className="visually-hidden">Chargement...</span>
        </div>
        <p className="text-muted">{message}</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;

// Manager Crée un Ordre (Draft)
//         |
//         | (Décision du Manager)
//         V
// Manager Clique sur "Soumettre à la Validation"
//         |
//         | (Déclenchement de SubmitOrderForValidationCommand)
//         V
// Système : Crée N tâches dans la table `Validations` (1 par validateur)
// Système : Met Order.ValidationStatus = PendingValidation
//         |
//         | (Notifications Email & Temps Réel)
//         V
// Tâche Apparaît dans le Dashboard des Validateurs
//         |
//         | (Décision des Validateurs)
//         +--> Approuvé -> Order.ValidationStatus = Validated -> Prêt pour Exécution
//         |
//         +--> Rejeté -> Order.ValidationStatus = Draft -> Retour au Manager pour Correction